module.exports = __webpack_public_path__ + "static/media/why-autzu.4a78a489.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/video-thumbnails/why-autzu.png
// module id = 2166
// module chunks = 0